import { render, staticRenderFns } from "./dialog_External.vue?vue&type=template&id=523db6ef&scoped=true&lang=html"
import script from "./dialog_External.vue?vue&type=script&lang=js"
export * from "./dialog_External.vue?vue&type=script&lang=js"
import style0 from "./dialog_External.vue?vue&type=style&index=0&id=523db6ef&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523db6ef",
  null
  
)

export default component.exports